<template>
    <b-row>
        <b-col
            cols="12"
            md="6"
        >
            <b-card>
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <b-form-group
                            label="Sepet Adı"
                            label-for="basketName"
                        >
                            <b-form-input
                                id="basketName"
                                v-model="search.basketName"
                                placeholder="Sepet adı"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col
                        cols="12"
                        md="6"
                    >
                        <b-form-group
                            label="Ürün Barkodu"
                            label-for="productBarcode"
                        >
                            <b-form-input
                                id="productBarcode"
                                v-model="search.productBarcode"
                                placeholder="Ürün barkodu"
                                @keyup.enter="getFbaProducts"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>

        <b-col
            cols="12"
            md="6"
        >

            <b-card>
                <b-button @click="getFbaProductBasket">
                    Ürünleri Getir
                </b-button>
                <b-button @click="printLabels">
                    Etiket Yazdır
                </b-button>
                <b-form-checkbox
                    :checked="$store.state.azFbaBasket.selectedBasketitems.length === $store.state.azFbaBasket.baskets.length && $store.state.azFbaBasket.baskets.length > 0"
                    @change="selectAllChanged"
                >
                    Tümünü Seç
                </b-form-checkbox>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'Search',
        data: () => ({

        }),
        computed: {
            ...mapState('azFbaBasket', ['search']),
        },
        methods: {
            selectAllChanged() {
                if (this.$store.state.azFbaBasket.selectedBasketitems.length < 1) {
                    this.$store.commit('azFbaBasket/setSelectedBasketitems', this.$store.state.azFbaBasket.baskets.map(basket => basket.id))
                } else {
                    this.$store.commit('azFbaBasket/setSelectedBasketitems', [])
                }
            },
            getFbaProducts() {
                this.$store.dispatch('azFbaBasket/getFbaProductsByBarcode', this.search.productBarcode)
            },
            getFbaProductBasket() {
                if (!this.search.basketName) {
                    alert('Lütfen sepet adı giriniz!')
                    return
                }
                this.$store.dispatch('azFbaBasket/getBaskets')
            },
            printLabels($event) {
                if (!this.$store.state.azFbaBasket.selectedBasketitems.length) {
                    alert('Lütfen en az bir ürün seçiniz!')
                    return
                }
                this.$root.$emit('bv::show::modal', 'fba-barcode-modal', $event.target)
            },
        },
    }
</script>
